<template>
    <div class="budgetary-legitimations" v-if="showTariff">
        <button class="float-right btn btn-outline-primary btn-sm pb-30-sm" @click="resetTariff">Restablecer</button>

        <form v-on:submit.prevent style="clear:both">
            <numeric-question v-model="numberOfDocuments" :min="1" @input="resetDocuments">
                ¿Cuántos documentos quieres testimoniar?

                <testimonials-document slot="single" ref="document" @updated="update"
                                       :has-international-document.sync="hasInternationalDocument"></testimonials-document>

                <assertive-question slot="multiple" v-if="numberOfDocuments" v-model="singleSignature" @input="resetDocuments">
                    ¿Todos los documentos son iguales?

                <testimonials-document slot="afirmative" ref="document" @updated="update"
                                       :has-international-document.sync="hasInternationalDocument"></testimonials-document>
                
                <accordion class="mb-4"
                            slot="negative"
                            v-for="n in numberOfDocuments"
                            :key="n"
                            dynamic-content
                            :dynamicRefreshTime="50">
                    <strong slot="title" class="mr-4">Documento {{ n }}</strong>
                    <small slot="title" class="mr-auto ml-4"></small>
                    <testimonials-document ref="document" :singleSignature="singleSignature" @updated="update"
                                           :has-international-document.sync="hasInternationalDocument"></testimonials-document>
                </accordion>

                </assertive-question>

            </numeric-question>
            <keep-alive>
                <assertive-question v-if="readyToCalculate" v-model="isCompany" afirmativeLabel="Empresa" negativeLabel="Particular" @input="calculate">
                    ¿La factura debe emitirse a nombre de empresa o particular?
                </assertive-question>
            </keep-alive>
        </form>

        <budget-summary v-if="readyToCalculate && cost" :cost="cost.base" :honoraries="cost.honoraries" :apostilles="cost.apostilles"
                        :untaxedCosts="cost.supplies" :retention="isCompany" service="testimonials"
                        :delivery-cost="deliveryCost">
            <slot name="callToActions"></slot>
        </budget-summary>

    </div>
</template>

<script>
const calculatePrice = require('./pricing')
    export default {

        data: function () {
            return {
                showTariff: true,

                cost: 0,
                untaxedCosts: 0,
                numberOfDocuments: null,
                isCompany: null,
                readyToCalculate: false,
                singleSignature: null,
                hasInternationalDocument: false,
                deliveryCost: 0
            }
        },

        methods: {
          resetTariff: function () {
            this.showTariff = false
            this.$nextTick(function () {
              this.showTariff = true
            })
          },

            update: function ( completed ) {
                this.$nextTick( () => {
                    this.readyToCalculate = this.isReadyToCalculate( completed );
                    if ( this.readyToCalculate && this.isCompany != null ) this.calculate();
                });
            },
            calculate: function () {
                let documents = [];
                if (this.$refs.document instanceof Vue) {
                    for (let i = 0; i < this.numberOfDocuments; i++) {
                        documents.push(
                            this.$refs.document.$data
                        )
                    }
                } else {
                  if ( typeof this.$refs.document === "undefined") {
                    return false
                  }
                   documents = this.$refs.document.map(document => document.$data)
                }
                this.cost = calculatePrice({documents})
                // Sumo el costo de mensajería
                this.cost.honoraries += this.hasInternationalDocument ? 7 : 0
                this.cost.base += this.hasInternationalDocument ? 7 : 0
                // Añado el costo de mensajería al detalle
                this.deliveryCost = this.hasInternationalDocument ? 7 : 0
            },
            isReadyToCalculate: function ( documentCompleteStatus ) {
                
                if ( documentCompleteStatus === false) return false;

                return this.areAllDocumentsCompleted( this.$refs.document );
            },
            areAllDocumentsCompleted: function ( documents ) {

                if ( this.$refs.document instanceof Vue ) {
                    return this.$refs.document.completed
                }

                let allDocumentsCompleted = null;

                _.forEach( documents, ( doc ) => {
                    allDocumentsCompleted = doc.completed;
                    if ( doc.completed === false ) return false;
                });

                return !! allDocumentsCompleted;
            },
            getJSON: function () {

                let json = [];
                json.push({
                    name: 'Tipo',
                    value: 'Legitimiaciones'
                });

                json.push({
                    "name": "¿Cuántos documentos desea testimoniar?",
                    "value": this.numberOfDocuments
                });

                if (this.numberOfDocuments === 1) {
                    json = json.concat(this.$refs.document.getJSON());
                } else {
                    json.push({
                        "name": "¿Todos los documentos son iguales?",
                        "value": this.singleSignature
                    });

                    if (this.singleSignature) {
                        json = json.concat(this.$refs.document.getJSON());
                    } else {
                        json.push(this.getDocumentJSONArray(this.$refs.document));
                    }
                }

                json.push({
                    "name": "¿La factura debe emitirse a nombre de empresa o particular?",
                    "value": this.isCompany ? 'Empresa' : 'Particular'
                });

                return json;
            },
            getDocumentJSONArray: function (documents) {
                let array = [];
                let index = 0;
                _.forEach(documents, (doc) => {
                    index++;
                    array.push({
                        "name": "Documento " + index,
                        "value": doc.getJSON()
                    });
                });
                return {
                    "name": "Documentos:",
                    "value": array
                }
            },
            resetDocuments: function () {
                this.readyToCalculate = false
            }
        },

        watch: {
            numberOfDocuments () {
                this.update()
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../../sass/variables";

    @media (max-width: 540px) {
        .budgetary-legitimations {
            padding-bottom: 80px;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/testimonials/TestimonialsBudgetary.vue